// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RecordsWrapper from "../../../../order-dashboard/view/components/non-live-order-dashboard/components/RecordsWrapper.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as IssueBriefPointerCmp from "./IssueBriefPointerCmp.bs.js";

var contactSeparator = " " + String.fromCharCode(183) + " ";

function whomToCallContact(whom_to_call) {
  var match = whom_to_call.name;
  var match$1 = whom_to_call.phone;
  if (match !== undefined) {
    if (match$1 !== undefined) {
      return match + contactSeparator + match$1;
    } else {
      return match;
    }
  }
  if (match$1 !== undefined) {
    return match$1;
  }
  var party = whom_to_call.party;
  if (party !== undefined) {
    return party;
  } else {
    return "--";
  }
}

function IssueBriefCmp(Props) {
  var issue_brief = Props.issue_brief;
  var start_here = issue_brief.start_here;
  var pointers = issue_brief.pointers;
  var generated_at = issue_brief.generated_at;
  var tmp;
  if (start_here !== undefined) {
    var probe = start_here.probe;
    tmp = probe !== undefined ? React.createElement("div", {
            className: "issue-brief-start-here"
          }, React.createElement("p", {
                className: "issue-brief-start-here-label"
              }, "Start here"), React.createElement("p", {
                className: "issue-brief-start-here-probe"
              }, probe)) : null;
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: "primary-card primary-info-card c-issue-brief"
            }, React.createElement("div", {
                  className: "header"
                }, React.createElement("p", {
                      className: "title"
                    }, "Issue Brief")), React.createElement(RecordsWrapper.make, {
                  children: null
                }, tmp, React.createElement(IssueBriefPointerCmp.make, {
                      title: "Whom to call",
                      clear: pointers.whom_to_call.clear,
                      line: pointers.whom_to_call.line,
                      contact: whomToCallContact(pointers.whom_to_call)
                    }), React.createElement(IssueBriefPointerCmp.make, {
                      title: "Why escalated",
                      clear: pointers.why_escalated.clear,
                      line: pointers.why_escalated.line
                    }), React.createElement(IssueBriefPointerCmp.make, {
                      title: "History",
                      clear: pointers.history.clear,
                      line: pointers.history.line
                    }), React.createElement(IssueBriefPointerCmp.make, {
                      title: "What's expected",
                      clear: pointers.whats_expected.clear,
                      line: pointers.whats_expected.line
                    }), React.createElement("p", {
                      className: "issue-brief-footer"
                    }, "Coverage: " + Belt_Option.getWithDefault(issue_brief.coverage.level, "NA"), generated_at !== undefined ? React.createElement("span", undefined, "Generated " + Timestamp$Catalyst.toString(Caml_option.valFromOption(generated_at), "DD/MM/YY h:mm a")) : null)));
}

var make = IssueBriefCmp;

export {
  contactSeparator ,
  whomToCallContact ,
  make ,
  
}
/* contactSeparator Not a pure module */
